import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[isophiHoverEffectSidebar]',
    standalone: false
})
export class HoverEffectSidebarDirective {
  @HostListener('mouseover') onHover() {
    if (window.innerWidth > 768) {
      document.querySelector('.sidenav-toggled')?.classList.add('sidenav-toggled1');
    }
  }

  @HostListener('mouseleave') onLeave() {
    if (window.innerWidth > 768) {
      document.querySelector('.sidenav-toggled')?.classList.remove('sidenav-toggled1');
    }
  }
}
